import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { AvField, AvForm, AvInput } from 'availity-reactstrap-validation';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Label } from 'reactstrap';

import { getDmxControllers, getDmxUniversesByController, getDmxProfiles, createDmxDevice } from '../../store/actions';

class CreateDmxDeviceForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      selectedControllerId: null,
      deviceType: 'LED',
      linkedEntityType: 'WORKSTATION_POSITION',
      selectedProfileId: '',
      startChannel: '',
      channelCount: '',
      popup: false,
      pop_msg: null,
      pop_err: null,
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidMount() {
    this.props.getDmxControllers(this.state.user);
    this.props.getDmxProfiles(this.state.user);
  }

  onDeviceTypeChange(deviceType) {
    this.setState({ deviceType, selectedProfileId: '' });
  }

  onProfileChange(profileId) {
    const profile = (this.props.profiles || []).find((p) => String(p.id) === String(profileId));
    this.setState({
      selectedProfileId: profileId,
      channelCount: profile ? profile.channel_count : this.state.channelCount,
    });
  }

  componentDidUpdate(prevProps) {
    const { messageDmxDevice, createDmxDeviceError, loadingCreateDmxDevice } = this.props;
    if (loadingCreateDmxDevice === false && prevProps.loadingCreateDmxDevice === true) {
      if (messageDmxDevice) {
        this.setState({ popup: true, pop_msg: 'Dispositivo creado correctamente' });
      } else if (createDmxDeviceError) {
        this.setState({ popup: true, pop_err: createDmxDeviceError.message || 'No se ha podido crear el dispositivo' });
      }
    }
  }

  confirmPopup() {
    this.setState({ popup: false });
    if (this.state.pop_msg) this.props.history.goBack();
  }

  onControllerChange(controllerId) {
    this.setState({ selectedControllerId: controllerId });
    if (controllerId) {
      this.props.getDmxUniversesByController(this.state.user, controllerId);
    }
  }

  handleValidSubmit(event, values) {
    const user = this.state.user;
    values.controller_id = Number(values.controller_id);
    values.universe_id = Number(values.universe_id);
    values.start_channel = Number(values.start_channel);
    values.channel_count = Number(values.channel_count);
    values.profile_id = Number(values.profile_id);
    values.token = user.token;
    this.props.createDmxDevice(values);
  }

  render() {
    const { controllers, universes, profiles } = this.props;
    if (!controllers) return null;
    const profilesForType = (profiles || []).filter((p) => p.device_type === this.state.deviceType);
    const lastChannel =
      this.state.startChannel && this.state.channelCount
        ? Number(this.state.startChannel) + Number(this.state.channelCount) - 1
        : '-';

    return (
      <Col lg="12">
        <Card>
          <CardBody>
            <CardTitle className="mb-4">{this.props.t('Crear dispositivo DMX')}</CardTitle>
            <AvForm className="needs-validation" onValidSubmit={this.handleValidSubmit}>
              <Col>
                <FormGroup>
                  <Label htmlFor="deviceName">{this.props.t('Nombre')}</Label>
                  <AvField
                    name="name"
                    type="text"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="deviceName"
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="deviceType">{this.props.t('Tipo')}</Label>
                  <AvInput
                    value={this.state.deviceType}
                    name="device_type"
                    type="select"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="deviceType"
                    onChange={(e) => this.onDeviceTypeChange(e.target.value)}
                  >
                    <option value="LED">LED</option>
                    <option value="SPOTLIGHT">SPOTLIGHT</option>
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="deviceProfile">{this.props.t('Perfil')}</Label>
                  <AvInput
                    name="profile_id"
                    type="select"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="deviceProfile"
                    value={this.state.selectedProfileId}
                    onChange={(e) => this.onProfileChange(e.target.value)}
                  >
                    <option value="">{this.props.t('Selecciona un perfil')}</option>
                    {profilesForType.map((p) => (
                      <option key={p.id} value={p.id}>
                        {p.name} ({p.channel_count} canales)
                      </option>
                    ))}
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="linkedEntityType">{this.props.t('Vinculado a')}</Label>
                  <AvInput
                    value={this.state.linkedEntityType}
                    name="linked_entity_type"
                    type="select"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="linkedEntityType"
                    onChange={(e) => this.setState({ linkedEntityType: e.target.value })}
                  >
                    <option value="WORKSTATION_POSITION">WORKSTATION_POSITION</option>
                    <option value="WORKSTATION">WORKSTATION</option>
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="linkedEntityId">{this.props.t('Posición / Estación (ws_pos o workstation)')}</Label>
                  <AvField
                    name="linked_entity_id"
                    type="text"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="linkedEntityId"
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="controllerId">{this.props.t('Controlador')}</Label>
                  <AvInput
                    name="controller_id"
                    type="select"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="controllerId"
                    onChange={(e) => this.onControllerChange(e.target.value)}
                  >
                    <option value="">{this.props.t('Selecciona un controlador')}</option>
                    {controllers.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.name} ({c.ip})
                      </option>
                    ))}
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="universeId">{this.props.t('Universo')}</Label>
                  <AvInput
                    name="universe_id"
                    type="select"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="universeId"
                  >
                    <option value="">{this.props.t('Selecciona un universo')}</option>
                    {(universes || []).map((u) => (
                      <option key={u.id} value={u.id}>
                        {u.universe_number} ({u.channel_count} canales)
                      </option>
                    ))}
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="startChannel">{this.props.t('Primer canal')}</Label>
                  <AvField
                    name="start_channel"
                    type="number"
                    className="form-control"
                    validate={{ required: { value: true }, min: { value: 1 } }}
                    id="startChannel"
                    onChange={(e) => this.setState({ startChannel: e.target.value })}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="channelCount">{this.props.t('Cantidad de canales')}</Label>
                  <AvField
                    name="channel_count"
                    type="number"
                    className="form-control"
                    validate={{ required: { value: true }, min: { value: 1 } }}
                    id="channelCount"
                    value={this.state.channelCount}
                    onChange={(e) => this.setState({ channelCount: e.target.value })}
                  />
                </FormGroup>
              </Col>
              <Col>
                <Label>
                  {this.props.t('Último canal')}: <b>{lastChannel}</b>
                </Label>
              </Col>
              <Button color="secondary" type="submit">
                {this.props.t('Crear dispositivo')}
              </Button>
            </AvForm>
            {this.state.popup ? (
              <SweetAlert
                type={this.state.pop_msg ? 'success' : 'error'}
                confirmBtnBsStyle={this.state.pop_msg ? 'success' : 'danger'}
                title={this.state.pop_msg ? this.state.pop_msg : this.state.pop_err}
                confirmBtnText={this.props.t('ok')}
                onConfirm={() => this.confirmPopup()}
              ></SweetAlert>
            ) : null}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateprops = (state) => {
  const { controllers } = state.getDmxControllers;
  const { universes } = state.getDmxUniversesByController;
  const { profiles } = state.getDmxProfiles;
  const { createDmxDeviceError, messageDmxDevice, loadingCreateDmxDevice } = state.createDmxDevice;
  return { controllers, universes, profiles, createDmxDeviceError, messageDmxDevice, loadingCreateDmxDevice };
};

export default withRouter(
  connect(mapStateprops, { getDmxControllers, getDmxUniversesByController, getDmxProfiles, createDmxDevice })(
    withNamespaces()(CreateDmxDeviceForm),
  ),
);
